import React from 'react';
import { SystemInput } from '../../components/input/SystemInput';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const SystemPicker = ({
  onChange,
  schema: { title = 'System', description = 'Select a system' },
  required,
  rawErrors,
  formData,
  idSchema,
  formContext,
}: FieldExtensionComponentProps<string>) => {
  return (
    <SystemInput
      label={title}
      helperText={description}
      error={rawErrors && rawErrors.length > 0 && !formData}
      required={required}
      id={idSchema?.$id}
      onChange={onChange}
      value={formData as string}
      team={formContext.formData.team}
    />
  );
};
